import { keyframes } from '@angular/animations';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {
  Observable,
  BehaviorSubject,
  map,
  Subject,
  interval,
  switchMap,
  tap,
  catchError,
  throwError,
} from 'rxjs';
import { FormGroup, FormControl } from '@angular/forms';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IssuesService {
  activeIssues: any;
  activeIssue: any;
  file_submission_name: any;
  loading = false;
  loadingCsv = false;
  loadingMail = false;
  signedOffIssues: any;

  private signedOffIssues$ = new BehaviorSubject<any[]>([]);
  public signedOffIssuesObservable = this.signedOffIssues$.asObservable();

  private activeIssues$ = new BehaviorSubject<any[]>([]);
  public activeIssuesObservable = this.activeIssues$.asObservable();

  constructor(private http: HttpClient, private api: ApiService) {
    this.activeIssues = [];
  }

  getActiveIssues(query?: string | null) {
    // The active-issues table has no real pager (p-table here is
    // [lazy]="true" purely to defer the initial load, with no
    // <p-paginator>/[rows] — it renders everything into one scrolling
    // container), but the backend still defaults to a 10-record page when
    // no limit is given. Without an explicit limit, `total_records` (22,
    // say) and `records.length` (10) silently diverge and newly created
    // issues outside that first page never appear. Match the same
    // large-limit workaround already used in job-form.component.ts for the
    // identical class of bug.
    let params = new HttpParams().set('skip', 0).set('limit', 1000);

    if (query) {
      params = params.set('q', query);
    }

    return this.api.getAPI<any>('activeissues', params);
  }


  getActiveIssueByVehicleId(
    vehicleId: any,
    page: number,
    rows: number,
    query?: string | null
  ) {
    let params = new HttpParams()
      .set('skip', (page - 1) * rows)
      .set('limit', rows);
    if (query) {
      params = params.set('q', query);
    }
    return this.api.getAPI<any>(`activeissues/vehicles/${vehicleId}`, params);
  }

  getSignedOffIssues(
    page: number,
    rows: number,
    query?: string | null
  ) {
    let params = new HttpParams()
      .set('skip', (page - 1) * rows)
      .set('limit', rows);
    if (query) {
      params = params.set('q', query);
    }
    return this.api.getAPI<any>('signedoffissues', params);
  }

  

  addActiveIssue(newIssue: any) {
    return this.api.postAPI<any>('activeissues', newIssue);
  }

  formatSubmittedIssue(issue: any) {
    if (!issue.description) {
      throw new Error('Description is missing');
    }

    // Extracting only the 'value' from each description object
    let taggedIssues = issue.description.map((element: any) => {
      return element.value;
    });

    let formattedIssue = {
      vehicle_reference: issue.vehicle_reference,
      description: taggedIssues,
      remarks: issue.remarks,
      vehicle_id: issue.vehicle_id,
    };
    return formattedIssue;
  }

  signOffActiveIssue(issue: any): Observable<any> {
    return this.api.patchAPI<any>('activeissues/sign-off', issue);
  }

  updateActiveIssue(issue_id: any, issue: any): Observable<any> {
    return this.api.updateAPI<any>('activeissues/update', issue_id, issue);
  }

  deleteActiveIssue(id: number) {
    return this.api.deleteAPI<any>('activeissues/delete', id).pipe(
      map((res) => {
        // // console.log('res', res);
        // this.getActiveIssues(1, 5);
        // this.getSignedOffIssues(1, 5);
      })
    );
  }

  getIssueReport() {
    this.loading = true;
    this.api.getFileAPI<any>('activeissues/generate-report').subscribe(
      (response: any) => {
        let contentDispositionHeader = response.headers.get(
          'Content-Disposition'
        );
        let fileName = '';

        if (contentDispositionHeader) {
          let matches = contentDispositionHeader.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          // Corrected the typo here: changed 'legnth' to 'length'
          if (matches && matches.length > 1) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }

        const blob: Blob = response.body as Blob;
        const a = document.createElement('a');
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      },
      (error) => {
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  sendIssueReport(email: any) {
    return this.api.postAPI<any>(
      `activeissues/send-report?email=${email}`,
      email
    );
  }

  getCsvReport() {
    this.loadingCsv = true;
    this.api.getFileAPI<any>('activeissues/generate-report-csv').subscribe(
      (response: any) => {
        let contentDispositionHeader = response.headers.get(
          'Content-Disposition'
        );
        let fileName = '';

        if (contentDispositionHeader) {
          let matches = contentDispositionHeader.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          // Corrected the typo here: changed 'legnth' to 'length'
          if (matches && matches.length > 1) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }

        const blob: Blob = response.body as Blob;
        const a = document.createElement('a');
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      },
      (error) => {
        this.loadingCsv = false;
      },
      () => {
        this.loadingCsv = false;
      }
    );
  }

  getActiveIssueVehicleCount(){
    return this.api.getAPI<any>('activeissues/vehicle-count');
  }
}

//   private updateActiveIssues(res: any): void {
//     this.activeIssues = res.body;
//     this.activeIssues$.next(this.activeIssues);
//   }

//   private handleError(error: any): Observable<never> {
//     console.error('Error updating active issue:', error);
//     return throwError(error);
//   }
// }
